import {TranslateService} from "@ngx-translate/core";

import {AutocompleteItem} from "../interface/text-editor.interface";

export class EditorTagsConverter {
  public static normalizeHtml(html: string): string {
    return html.replace(/\r/g, '');
  }

  static createEditorTagElementAsString(tag: string, title?: string): string {
    return `<code contenteditable="false" data-variable="${tag}">@${title || tag}</code>`;
  }

  static toEditorFormat(input: string, getTitleFn: (tag: string) => string): string {
    return EditorTagsConverter.normalizeHtml(input).replace(/%\{(\w+)\}/g, (_, tag) => {
      return EditorTagsConverter.createEditorTagElementAsString(tag, getTitleFn(tag));
    });
  }

  static toBackendFormat(input: string): string {
    return EditorTagsConverter.normalizeHtml(input).replace(
      /<code[^>]*data-variable="(\w+)"[^>]*>[^<]*<\/code>/g,
      (_, tag) => `%{${tag}}`,
    );
  }
}

export function toAutocompleterItemsArray(
  variables: string[],
  translatesMap: Map<string, string>,
  trs: TranslateService
): AutocompleteItem[] {
  return variables.map((variable) => {
    return {
      value: variable,
      text: trs.instant(translatesMap.get(variable) || variable)
    };
  });
}
